// extracted by mini-css-extract-plugin
export var circle = "_1e-2";
export var icon = "_1e-a";
export var iconHighlight = "_1e-0";
export var lg = "_1e-8";
export var md = "_1e-7";
export var outline = "_1e-4";
export var sm = "_1e-6";
export var square = "_1e-1";
export var xl = "_1e-9";
export var xs = "_1e-5";
export var xxs = "_1e-3";